<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading :module-id="access.module_id" :profile-id="access.profile_id" :reference="access.view_reference" summary-only />
          <div class="list-view-heading__controls"><div class="list-view-heading__actions"><TabHeaderActions /></div></div>
        </section>
      </b-card>

      <b-card v-if="arr.report">
        <div class="app-modal-header mb-3">
          <span class="app-modal-header__icon"><AppIcon name="chat" /></span>
          <h5 class="app-modal-header__title">Novedad #{{ arr.report.id }}</h5>
        </div>

        <div class="app-modal-detail-list">
          <div class="app-modal-detail-list__row">
            <span class="app-modal-detail-list__label">Fecha</span>
            <span class="app-modal-detail-list__value">{{ moment(arr.report.date).format('DD MMMM YYYY') }}</span>
          </div>
          <div class="app-modal-detail-list__row" v-if="responsible">
            <span class="app-modal-detail-list__label">Responsable</span>
            <span class="app-modal-detail-list__value d-flex align-items-center">
              <b-avatar v-if="responsible.image" :src="responsible.image" size="25px" />
              <b-avatar v-else size="25px" :text="avatarFromName(responsible.name).text" :style="avatarFromName(responsible.name).style" />
              <strong class="ml-2">{{ responsible.name }}</strong>
            </span>
          </div>
          <div class="app-modal-detail-list__row" v-if="arr.report.customer">
            <span class="app-modal-detail-list__label">Cliente</span>
            <span class="app-modal-detail-list__value d-flex align-items-center">
              <b-avatar v-if="arr.report.customer.image" :src="arr.report.customer.image" size="25px" />
              <b-avatar v-else size="25px" :text="avatarFromName(arr.report.customer.name).text" :style="avatarFromName(arr.report.customer.name).style" />
              <strong class="ml-2">{{ arr.report.customer.name }}</strong>
              <AppIcon v-if="!arr.report.customer.active" name="circle-fill" fill class="ml-2 text-danger" v-b-tooltip.hover title="Cliente inactivo" />
            </span>
          </div>
          <div class="app-modal-detail-list__row" v-if="arr.report.observations">
            <span class="app-modal-detail-list__label">Observaciones</span>
            <span class="app-modal-detail-list__value detail-report-observations">{{ arr.report.observations }}</span>
          </div>
        </div>
      </b-card>

      <b-card v-else-if="!isBusy">
        <EmptyState icon="chat" title="No se encontró la novedad" description="El registro no está disponible o fue eliminado." />
      </b-card>

      <b-card body-class="py-2">
        <section class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)"><AppIcon name="arrow_back" class="mr-1" /> Volver</b-button>
        </section>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import serviceAPI from './services'
import Error from '@/handler/error'
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Helper from '@/handler/helper'
import Funciones from '@/handler/funciones'
import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
import moment from 'moment'

export default {
  components: { TabHeaderActions },
  data: () => ({
    access: { module_id: Modules.INFORME_NOVEDADES, profile_id: Profiles.PERSONAL, view_reference: 'detailReport', elements: {} },
    reportID: 0,
    isBusy: true,
    arr: { report: null },
  }),
  computed: {
    responsible() {
      if (!this.arr.report) return null
      return this.arr.report.staff_id ? this.arr.report.staff : (this.arr.report.seller && this.arr.report.seller.staff)
    },
  },
  created() {
    Helper.hasAccessView(this.access)
  },
  mounted() {
    this.reportID = this.$route.params.reportID
    this.load()
  },
  methods: {
    moment,
    avatarFromName(name) {
      return Funciones.avatarFromName(name)
    },
    validation() {
      var seller = Helper.getSeller()
      if (seller && this.arr.report.sellers_id !== seller.id) this.$router.push({ name: 'Error403' })
    },
    load() {
      serviceAPI.mostrar(this.reportID)
        .then((response) => {
          this.arr.report = response.data
          this.isBusy = false
          this.validation()
        })
        .catch((error) => {
          this.isBusy = false
          this.$awn.alert(Error.showError(error))
        })
    },
  },
}
</script>

<style>
.detail-report-observations {
  white-space: pre-line;
}
</style>
